import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedTime } from 'react-intl';
import { CircularProgress, Menu, MenuItem, Button } from '@material-ui/core';

import { FormattedMessageWrappedInSpan } from '../../misc';
import CustomDate from '../../misc/CustomDate';

const StravaActivitiesSelection = (props) => {
  const {
    stravaActivities,
    isAuthorizationError,
    noStravaActivitiesFoundCallback,
    fileSelectedManually,
    handleFileSelectedManuallyCallback,
    setUpStravaActivity,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStravaActivityName, setSelectedStravaActivityName] = useState();

  const { activities } = stravaActivities;

  const hasOnlyOneMatchingActivity = activities.length === 1;

  const MAX_CHAR_IN_GPX_FILE_NAME = 25;
  const OPTION_HEIGHT = 26;

  useEffect(() => {
    if (activities.length === 0) {
      noStravaActivitiesFoundCallback();
    }
  }, [activities]);

  useEffect(() => {
    if (hasOnlyOneMatchingActivity) {
      const onlyActivity = activities[0];
      handleActivitySelect(onlyActivity.id, onlyActivity.name, onlyActivity.startDate);
    }
  }, [activities, hasOnlyOneMatchingActivity]);

  const shortActivityName = (name) => {
    let shortActivityName;
    if (name.length <= MAX_CHAR_IN_GPX_FILE_NAME) {
      shortActivityName = name;
    } else {
      shortActivityName = `${name.substring(0, MAX_CHAR_IN_GPX_FILE_NAME)}...`;
    }
    return shortActivityName;
  };

  const handleActivitySelect = (activityId, activityName, activityStartDate) => {
    const shortName = shortActivityName(activityName);
    setSelectedStravaActivityName(shortName);
    setUpStravaActivity({stravaActivityId: activityId, stravaActivityStartDate: activityStartDate});
  };

  const handleMenuOpen = (event) => {
    if (!hasOnlyOneMatchingActivity) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (fileSelectedManually) {
      handleFileSelectedManuallyCallback();
      setSelectedStravaActivityName();
    }
  }, [fileSelectedManually]);

  return (
    <>
      {!isAuthorizationError && (
        <div>
          <Button classes={{ root: 'gps-search-upload-btn' }} onClick={handleMenuOpen}>
            {selectedStravaActivityName && selectedStravaActivityName}
            {activities.length === 0 && <CircularProgress size={24} thickness={3} />}
            {!selectedStravaActivityName && activities.length > 0 && (
              <FormattedMessageWrappedInSpan
                id="extendedSearchGpsSearchTab.ownSearch.stravaSelectButton"
                defaultMessage="Choose an activity"
              />
            )}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                maxHeight: `${OPTION_HEIGHT * 5 + 8}px`,
                minWidth: `120px`,
              },
            }}
          >
            {stravaActivities.activities.map((activity) => {
              return (
                <MenuItem
                  data-test-id={`activity-${activity.id}`}
                  key={activity.id}
                  onClick={() => {
                    handleActivitySelect(activity.id, activity.name, activity.startDate);
                    handleMenuClose();
                  }}
                >
                  {
                    <div className="strava-activities-menu-item">
                      <span>{`${shortActivityName(activity.name)}`}</span>
                      {activity.startDate && (
                        <span className="strava-activities-menu-item__dates typography text-color_light typography-caption_small">
                          <span>
                            <CustomDate value={activity.startDate} />
                          </span>
                          <span>
                            <FormattedTime value={activity.startDate} />
                          </span>
                        </span>
                      )}
                    </div>
                  }
                </MenuItem>
              );
            })}
          </Menu>
        </div>
      )}
    </>
  );
};

StravaActivitiesSelection.propTypes = {
  stravaActivities: PropTypes.object,
  isAuthorizationError: PropTypes.bool,
  noStravaActivitiesFoundCallback: PropTypes.func,
  fileSelectedManually: PropTypes.bool,
  handleFileSelectedManuallyCallback: PropTypes.func,
  setUpStravaActivity: PropTypes.func,
};

export default StravaActivitiesSelection;
